const getItemsSorted = (itemKeys, itemsData) => {
    const sortedItems = itemKeys.sort(function(a, b) {
        const movieA = itemsData[a]
        const movieB = itemsData[b]
        
        const aName = movieA.title
        const bName = movieB.title 
        
        return bName > aName ? -1 : bName < aName ? 1 : 0
    })

    return sortedItems
}

export default getItemsSorted
